import { render, staticRenderFns } from "./searchHourse.vue?vue&type=template&id=2bff585e&"
import script from "./searchHourse.vue?vue&type=script&lang=js&"
export * from "./searchHourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports